import React from "react";
import PropTypes from "prop-types";
import { Navbar, useMyDpdTheme, THEME, Divider, Menu } from "@dpdgroupuk/mydpd-ui";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import { Container } from "react-bootstrap";
import { PROJECT_NAME, M, ROUTE, FRIENDLY_PROJECT_NAME } from "../../constants";
import { useAppContext } from "../../Context";
import Search from "../Search";
import UserProfileMenu from "../../components/Profile";
import { SecondaryMenu, ThirdMenu } from "../../components/Menu";
import { AuthUtil } from "../../utils";
import "./styles.scss";

const noop = () => null;

const getPrimaryMenuItem = projectName => ({
  eventKey: projectName,
  name: FRIENDLY_PROJECT_NAME[projectName]
});

const Header = ({
  className,
  onClickDpdLogo,
  onClickLogOff,
  onPrimaryMenuSelect,
  onSecondaryMenuSelect,
  secondaryMenuItems,
  thirdMenuItems,
  onThirdMenuSelect
}) => {
  const {
    projectName,
    state,
    urlResolver
  } = useAppContext();
  const auth = state.auth;
  const theme = useMyDpdTheme();
  const utilityLinks = React.useMemo(() => [{
    to: auth.user ? ROUTE.LOGOUT_PAGE : ROUTE.LOGON_PAGE,
    as: NavLink,
    eventKey: auth.user ? "mydpd.logout" : "mydpd.login",
    name: auth.user ? M.LOGOUT : M.LOGIN,
    onClick: onClickLogOff
  }], [urlResolver, auth.user, onClickLogOff]);
  const primaryMenuItems = React.useMemo(() => {
    const tabs = [{ ...getPrimaryMenuItem(PROJECT_NAME.MYDPD),
      name: theme.themeName === THEME.DPD ? M.MY_DPD : M.MY_DPD_LOCAL
    }, getPrimaryMenuItem(PROJECT_NAME.SHIPPING), getPrimaryMenuItem(PROJECT_NAME.COLLECTIONS), getPrimaryMenuItem(PROJECT_NAME.DELIVERIES), getPrimaryMenuItem(PROJECT_NAME.PICKUP_RETURNS), getPrimaryMenuItem(PROJECT_NAME.DATA), getPrimaryMenuItem(PROJECT_NAME.DEPOT_FINDER)];
    return tabs.map(tab => ({
      eventKey: tab.eventKey,
      href: urlResolver.getUrl(tab.eventKey),
      name: tab.name
    }));
  }, [theme, urlResolver]);
  React.useEffect(() => {
    document.title = `${theme.themeName === THEME.DPD ? M.DPD : M.DPD_LOCAL} - ${FRIENDLY_PROJECT_NAME[projectName]}`;
  }, []);
  return /*#__PURE__*/React.createElement("header", {
    className: classNames("mydpd-header", className)
  }, /*#__PURE__*/React.createElement(Navbar, null, /*#__PURE__*/React.createElement(Container, {
    className: classNames("mydpd-navbar-container")
  }, /*#__PURE__*/React.createElement(Navbar.Brand, {
    onClick: onClickDpdLogo,
    href: theme.dpdDomain
  }), /*#__PURE__*/React.createElement(Navbar.Collapse, {
    id: "responsive-navbar-nav",
    className: classNames("mydpd-navbar-collapse")
  }, /*#__PURE__*/React.createElement(Menu.Primary, {
    activeKey: projectName,
    items: primaryMenuItems,
    onSelect: onPrimaryMenuSelect
  })), /*#__PURE__*/React.createElement("div", {
    className: "mydpd-navbar-right-menu d-flex justify-content-end"
  }, auth.user && /*#__PURE__*/React.createElement(Search, null), /*#__PURE__*/React.createElement(UserProfileMenu, {
    links: utilityLinks,
    header: auth.user ? `Welcome, ${AuthUtil.getDisplayName(auth.user)}` : "You're not authorised"
  }), /*#__PURE__*/React.createElement(Navbar.Toggle, {
    "aria-controls": "responsive-navbar-nav"
  })))), !!secondaryMenuItems.length && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(SecondaryMenu, {
    items: secondaryMenuItems,
    onSelect: onSecondaryMenuSelect
  })), /*#__PURE__*/React.createElement(Divider, null)), !!thirdMenuItems.length && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ThirdMenu, {
    items: thirdMenuItems,
    onSelect: onThirdMenuSelect
  }), /*#__PURE__*/React.createElement(Divider, null)));
};

Header.defaultProps = {
  secondaryMenuItems: [],
  thirdMenuItems: [],
  onClickDpdLogo: noop,
  onClickLogOff: noop,
  onPrimaryMenuSelect: noop,
  onSecondaryMenuSelect: noop,
  onThirdMenuSelect: noop
};
Header.propTypes = {
  className: PropTypes.string,
  onClickDpdLogo: PropTypes.func,
  onClickLogOff: PropTypes.func,
  secondaryMenuItems: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    to: PropTypes.string,
    name: PropTypes.string
  })),
  thirdMenuItems: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    to: PropTypes.string,
    name: PropTypes.string
  })),
  onPrimaryMenuSelect: PropTypes.func,
  onSecondaryMenuSelect: PropTypes.func,
  onThirdMenuSelect: PropTypes.func
};
export default Header;